export const PlaneNormal = {
  XAxis: 0,
  YAxis: 1,
  ZAxis: 2,
};

export default {
  PlaneNormal,
};
